<template>
  <div class="modal-merge-platform">
    <el-dialog
      :visible.sync="visible"
      lock-scroll
      custom-class="mini outside"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="提示"
      @close="$_cancle"
    >
      <div class="content">
        很抱歉，运营商创建失败：
        <br />
        系统已存在开通了其他餐道应用的同名运营商{{ data.platformName }}。
        <div style="margin-bottom: 15px"></div>
        您可以：
        <br />
        1. 查看同名运营商
        <span class="text" @click="innerVisible = true">
        {{ data.platformName }}
        </span>
        ，若确认为同一个用户的运营商，可点击【合并运营商】继续操作；
        <br />
        2. 创建其他不同名的运营商。
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="save__btn" @click="$_callback">合并运营商</el-button>
          <el-button class="cancel__btn" @click="$_cancle">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog :visible.sync="innerVisible" custom-class="mini inside" title="提示">
      <div class="row">
        <span>运营商名称:</span>
        <span>{{ data.platformName }}</span>
      </div>
      <div class="row">
        <span>共享运营商ID:</span>
        <span>{{ data.id }}</span>
      </div>
      <div class="row">
        <span>共享运营商编码:</span>
        <span>{{ data.merchantId }}</span>
      </div>
      <div class="row">
        <span>运营商类型:</span>
        <span>{{ data.platformType === 1 ? '餐饮' : data.platformType === 2 ? '零售' : '' }}</span>
      </div>
      <div class="row">
        <span>备注:</span>
        <span>{{ data.memo }}</span>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="cancel__btn" @click="innerVisible = false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "modal-merge-platform",
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      visible: false,
      innerVisible: false
    };
  },
  methods: {
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    $_callback() {
      this.$emit("callback");
      this.visible = false
    },
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss">
.modal-merge-platform {
  .el-dialog.outside {
    width: 640px;
    .el-dialog__body {
      padding: 30px;
      height: 200px;
    }
  }
  .el-dialog.inside {
    .el-dialog__body {
      padding: 30px;
      height: 250px;
    }
  }
  .text {
    cursor: pointer;
    color: #1895dd;
    text-decoration: underline;
  }
  .row {
    margin: 15px;
    span:first-child {
      display: inline-block;
      width: 100px;
    }
  }
}
</style>
